import React, {useState} from 'react';
import {PageDataContainerStyled} from "../../../styled/Resume";
import Button from "../../UI/Buttons/Button";
import {useTheme} from "../../UI/Theme/ThemeContext";
import CreateStep from "../Steps/Create/CreateStep";

const CreatePageData = (props) => {
    const [stepsDone, setStepsDone] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const {
        optimizeBasicInfo,
        optimizeHandleInputChange,
        optimizeJobConnectType,
        optimizeJobTypesArray,
        optimizeHandleJobConnectType,
        optimizeSetAdditionalInfo,
        optimizeAdditionalInfo,
        basicLinkInfo,
        basicHandleAddLinks,
        basicHandleDeleteLinks,
        basicHandleLinkChange,
        eduArray,
        handleEduExpChange,
        handleDeleteEduInfo,
        handleAddEduInfo,
        workExpArray,
        handleWorkExpChange,
        handleDeleteExp,
        handleAddExp,
        skills,
        handleSkillChange,
        handleDeleteSkill,
        handleAddSkill,
        awardArray,
        handleAwardChange,
        handleDeleteAward,
        handleAddAward,
        publications,
        handlePubChange,
        handleDeletePublication,
        handleAddPublication,
        languages,
        handleLangChange,
        languageStore,
        langLevelsArray,
        handleDeleteLang,
        handleAddLang,
        interests,
        handleInterestChange,
        handleDeleteInterests,
        handleAddInterests,
        basicInfoForward,
        eduInfoForwardOrBackward,
        workExpForwardOrBackward,
        skillsForwardOrBackward,
        certsForwardOrBackward,
        pubForwardOrBackward,
        langForwardOrBackward,
        interestsBackward,
        onSubmitCreate

    } = props;
    const {themeName} = useTheme();
    

    return (
        <PageDataContainerStyled theme={themeName}>
            <CreateStep
                setStepsDone={setStepsDone}
                basicInfo={optimizeBasicInfo}
                handleInputChange={optimizeHandleInputChange}
                jobConnectType={optimizeJobConnectType}
                jobTypesArray={optimizeJobTypesArray}
                handleJobConnectType={optimizeHandleJobConnectType}
                setAdditionalInfo={optimizeSetAdditionalInfo}
                additionalInfo={optimizeAdditionalInfo}
                onSubmitCreate={onSubmitCreate}
                basicLinkInfo={basicLinkInfo}
                basicHandleAddLinks={basicHandleAddLinks}
                basicHandleDeleteLinks={basicHandleDeleteLinks}
                basicHandleLinkChange={basicHandleLinkChange}
                eduArray={eduArray}
                handleEduExpChange={handleEduExpChange}
                handleDeleteEduInfo={handleDeleteEduInfo}
                handleAddEduInfo={handleAddEduInfo}
                workExpArray={workExpArray}
                handleWorkExpChange={handleWorkExpChange}
                handleDeleteExp={handleDeleteExp}
                handleAddExp={handleAddExp}
                skills={skills}
                handleSkillChange={handleSkillChange}
                handleDeleteSkill={handleDeleteSkill}
                handleAddSkill={handleAddSkill}
                awardArray={awardArray}
                handleAwardChange={handleAwardChange}
                handleDeleteAward={handleDeleteAward}
                handleAddAward={handleAddAward}
                publications={publications}
                handlePubChange={handlePubChange}
                handleDeletePublication={handleDeletePublication}
                handleAddPublication={handleAddPublication}
                languages={languages}
                handleLangChange={handleLangChange}
                languageStore={languageStore}
                langLevelsArray={langLevelsArray}
                handleDeleteLang={handleDeleteLang}
                handleAddLang={handleAddLang}
                interests={interests}
                handleInterestChange={handleInterestChange}
                handleDeleteInterests={handleDeleteInterests}
                handleAddInterests={handleAddInterests}
                basicInfoForward={basicInfoForward}
                eduInfoForwardOrBackward={eduInfoForwardOrBackward}
                workExpForwardOrBackward={workExpForwardOrBackward}
                skillsForwardOrBackward={skillsForwardOrBackward}
                certsForwardOrBackward={certsForwardOrBackward}
                pubForwardOrBackward={pubForwardOrBackward}
                langForwardOrBackward={langForwardOrBackward}
                interestsBackward={interestsBackward}

            />
            {stepsDone &&
                <Button
                    primary={true}
                    width="50%"
                    title={submitting ? "Submitting..." : "Build & Preview"}
                    disabled={submitting}
                    clickHandle={async (e) => {
                        if (typeof onSubmitCreate === 'function') {
                            try { setSubmitting(true); await onSubmitCreate(e); } finally { setSubmitting(false); }
                        }
                    }}
                />
            }

        </PageDataContainerStyled>

    );
}

export default CreatePageData